import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMySSOUrl } from '@sentara-health/sentara-api-hooks-core';
import { errorhandler, navigateToExternalUrl } from 'common';
import { GlobalContext,isAvMed } from 'context';
import { Headings, Loader } from '@sentara-health/optimahealth_web';
import TreatmentEstimateCards from './TreatmentEstimateCards';

function TreatmentEstimateCosts() {
   const { getFeature,ssoEndPoints } = useContext(GlobalContext);
  const [loading, setLoading] = useState<any>(false);
  const { t } = useTranslation();
  const { SSOUrlType } = useMySSOUrl();

  
  // Redirect to SSO URL 
  const redirectToUrl = (urltype:string) => {
    if (isAvMed()){
      navigateToExternalUrl(urltype);
    }else{
     getAPIUrl(urltype);
    }    
  };
  const getAPIUrl = async (type: string) => {
    setLoading(true);
    const res = await SSOUrlType(type);
    if (res?.data) {
      window.open(res?.data?.ssoUrl, '_blank');
    } else if (res?.errorCode) {
      errorhandler(res?.errorCode);
    }
    setLoading(false);
  };
  
  return (
    <>
      {loading && <Loader />}
      <div className="mb-4">
        <Headings
          level={1}
          text={t('common.calculateTreatmentCosts')}
          variant="semiBold"
          dataTestId="estimateTreatmentCostsHeader"
        />
      </div>
      <div className="row estimated_treat_cost_content">
        <TreatmentEstimateCards
            featureEnabled={getFeature?.IBMEstimateTreatmentCosts}
            heading={t('costsCalculate.totalCost')}
            description={t('costsCalculate.totalCostDescription')}
            dataTestId='totalCostTreatmentEstimator'
            buttonLabel={t('costsCalculate.view')}
            getAPIUrl={() => getAPIUrl(ssoEndPoints?.CalculateTreatmentCostUrl)}
          />

          <TreatmentEstimateCards
            featureEnabled={getFeature?.HSQEstimateTreatmentCosts}
            heading={t('costsCalculate.CPT')}
            description={t('costsCalculate.CPTDescription')}
            dataTestId='cptCodeTreatmentEstimator'
            buttonLabel={t('costsCalculate.view')}
             getAPIUrl={() => getAPIUrl(ssoEndPoints?.HSQCalculateTreatmentCostUrl)}
          />
       
      </div>
    </>
  );
}

export default TreatmentEstimateCosts;
